import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Logo } from "../components/Logo";
import { toast } from "sonner";

const inp = "w-full bg-[#F3F0F5] rounded-lg px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-brand-purple/20";

export default function SetPassword() {
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/auth/set-password/${encodeURIComponent(token)}`).then(({ data }) => setInfo(data)).catch((e) => setErr(formatApiError(e.response?.data?.detail))); }, [token]);
  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) return toast.error("Password must be at least 6 characters");
    if (pw !== pw2) return toast.error("Passwords don't match");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/set-password", { token, password: pw });
      localStorage.setItem("ev_token", data.token);
      await refresh();
      toast.success("Password set — welcome to your portal");
      navigate(data.project_id ? `/client/projects/${data.project_id}?welcome=1` : "/client", { replace: true });
    } catch (e2) { toast.error(formatApiError(e2.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#FAFAFC]" data-testid="set-password-page">
      <div className="w-full max-w-sm bg-white rounded-2xl border border-border p-8">
        <Logo />
        <h1 className="mt-6 font-heading font-extrabold text-2xl text-brand-purpleDeep">Set your password</h1>
        {err ? <><p className="mt-3 text-sm text-red-600" data-testid="set-password-error">{err}</p><Link to="/login?mode=link" className="mt-4 inline-block text-brand-purple font-semibold text-sm">Request a new link</Link></>
          : !info ? <p className="mt-3 text-sm">Checking your link…</p>
          : <form onSubmit={submit} className="mt-5 space-y-3"><p className="text-sm text-brand-purpleDeep/60">For <b data-testid="set-password-email">{info.email}</b>. Your booking is already saved as a draft project.</p>
            <input type="password" className={inp} placeholder="New password (min 6)" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="set-password-input" />
            <input type="password" className={inp} placeholder="Confirm password" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="set-password-confirm" />
            <button disabled={busy} className="w-full bg-brand-orange text-white font-semibold py-3 rounded-lg disabled:opacity-50" data-testid="set-password-submit">{busy ? "Saving…" : "Set password & open my project"}</button></form>}
      </div>
    </div>
  );
}
